export const BUFFER_MINUTES = 10
export const BUFFER_MS = BUFFER_MINUTES * 60 * 1000

export function calculateTimeRemaining(timeEntered: string): number {
  const enteredAt = new Date(timeEntered).getTime()
  const expiresAt = enteredAt + BUFFER_MS
  const now = Date.now()
  return Math.max(0, expiresAt - now)
}

export function formatTimeRemaining(ms: number): string {
  if (ms <= 0) return '00:00'
  const totalSeconds = Math.floor(ms / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

export function formatTimeAgo(dateString: string): string {
  const date = new Date(dateString)
  const now = new Date()
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000)

  if (seconds < 60) return 'just now'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  return date.toLocaleDateString()
}
